import { Navigate, Route, Routes } from "react-router-dom";
import AdminPage from "src/components/pages/admin/admin";
import HomePage from "src/components/pages/home/home";
import GapPage from "src/components/pages/gap/gap";
import RegionPreferencesPage from "src/components/pages/changeRegion/changeRegion";
import { useAppSelector } from "src/store/store";
import ConversationDetail from "src/components/pages/admin/conversationDetail";
import ConversationList from "src/components/pages/admin/conversationsList";
import Unauthorized from "src/components/routes/unauthorized";

const MainContent = () => {
  const { token, isAuthorized, isAdministrator } = useAppSelector(
    (state) => state.user,
  );
  const { isChangeRegionEnabled } = useAppSelector((state) => state.ui);

  return (
    <div className="main">
      {!token || !isAuthorized ? (
        <Unauthorized />
      ) : (
        <Routes>
          {/* Home Route: Renders HomePage component when path is exactly "/" */}
          <Route path="/" element={<HomePage />} />

          {/* Saige Route: Renders HomePage component while keeping /saige URL */}
          <Route path="/saige" element={<HomePage />} />

          {/* Mcp Route: Renders HomePage component with mcp feature */}
          <Route path="/mcp" element={<HomePage />} />

          {/* Gap Route: Renders GapPage component for document analysis */}
          <Route path="/gap" element={<GapPage />} />

          {/* Region Preferences Route */}
          {isChangeRegionEnabled && (
            <Route path="/change-region" element={<RegionPreferencesPage />} />
          )}

          {/* Admin Route: Only rendered if isAdministrator is true*/}
          {isAdministrator && (
            <Route path="/admin" element={<AdminPage />}>
              <Route index element={<ConversationList />} />
              <Route path=":conversationId" element={<ConversationDetail />} />
            </Route>
          )}

          {/* Catch-all Route: Handles any undefined routes
              The "*" matches any route not defined above
              Navigate component redirects to home page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
    </div>
  );
};

export default MainContent;
